module.exports = __webpack_public_path__ + "img/carousel-2.6c1b2ce3.png";